import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

// material-ui
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

// project imports
import NavItem from './NavItem';
import { useGetMenuMaster } from 'api/menu';

// assets
import DownOutlined from '@ant-design/icons/DownOutlined';
import RightOutlined from '@ant-design/icons/RightOutlined';

export default function NavCollapse({ item, level }) {
  const { pathname } = useLocation();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const isChildSelected = useMemo(
    () => item.children?.some((child) => child.url && matchPath({ path: child.url, end: false }, pathname)),
    [item.children, pathname]
  );

  const [open, setOpen] = useState(Boolean(isChildSelected));

  const Icon = item.icon;
  const itemIcon = item.icon ? <Icon style={{ fontSize: drawerOpen ? '1rem' : '1.25rem' }} /> : null;

  return (
    <>
      <ListItemButton
        onClick={() => setOpen((prev) => !prev)}
        selected={isChildSelected}
        sx={() => {
          const subtleActiveBg = 'rgba(255, 255, 255, 0.1)';
          return {
          pl: drawerOpen ? `${level * 28}px` : 1.5,
          py: !drawerOpen && level === 1 ? 1.25 : 1,
          '&:hover': { bgcolor: subtleActiveBg },
          '&.Mui-selected': {
            bgcolor: subtleActiveBg,
            borderRight: '2px solid',
            borderColor: 'primary.main'
          }
          };
        }}
      >
        {itemIcon && <ListItemIcon sx={{ minWidth: 28 }}>{itemIcon}</ListItemIcon>}
        {(drawerOpen || (!drawerOpen && level !== 1)) && (
          <ListItemText
            primary={
              <Typography variant="h6" sx={{ color: '#fff' }}>
                {item.title}
              </Typography>
            }
          />
        )}
        {(drawerOpen || (!drawerOpen && level !== 1)) && (open ? <DownOutlined /> : <RightOutlined />)}
      </ListItemButton>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List disablePadding>
          {item.children?.map((child) => (
            <NavItem key={child.id} item={child} level={level + 1} />
          ))}
        </List>
      </Collapse>
    </>
  );
}

NavCollapse.propTypes = {
  item: PropTypes.object.isRequired,
  level: PropTypes.number
};
